const jsonStyle = [
  {
    "mapTypeControl": false,
    "featureType": "poi",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  }
];

const mapStyles = {
    styles: jsonStyle,
    mapTypeControl: false,
    streetViewControl: false
};

export default mapStyles;


// WEBPACK FOOTER //
// ./src/utils/mapStyles.js